import React, { useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";

export default function ReportMessageModal({
  message,
  cancelModal,
  fetchData,
}) {

  // styled

  const [isLoading, setIsLoading] = useState(false);
  const [complete,setComplete] = useState(false)
  const {user} = useAuthContext();

  const handleReport = async () => {
    setIsLoading(true);
  
    try {
      const reportResponse = await axios.post(
        `${ApiConnectionString}/api/report/message/${message.id}`,
        {},  // No data being sent, pass an empty object
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
  
      if (reportResponse.status === 200) {
        setComplete(true);
        fetchData();
      }
    } catch (error) {
      console.error('Error reporting message:', error);
    } finally {
      setIsLoading(false);
    }
  };
  

  if(isLoading){
    return (
        <div className="send-modal-overlay">
          <div className="send-modal">      
        <LoadingSpinner />
            <div className="send-modal-footer">           
            </div>
          </div>
        </div>
      );
  }
  else{
    if(complete){
        return (
            <div className="send-modal-overlay">
              <div className="send-modal">
              <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Message Reported</p></div> 
              <p>The message has been reported.</p>
              <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
                <div className="send-modal-footer">
                <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Close
                </button>
                </div>
              </div>
            </div>
          );
    }else{
        return (
            <div className="send-modal-overlay">
              <div className="send-modal">
              <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Report Message</p></div> 
              <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
             
                <p>"
                  {message.content > 100
                    ? `${message.content.slice(0, 100)}...`
                    : message.content}
                "</p>
                <p>Are you sure that you want to report this message?</p>
                <div className="send-modal-footer">
                  <button
                    className="saveChanges-button mx-3"
                    onClick={handleReport}
                    disabled={isLoading}
                  >Confirm
                   
                  </button>
                  <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
                </div>
              </div>
            </div>
          );
    }
  }


}
